import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const TrainingRegisterComponent = () => {
    const [showPopupMessage, setShowPopupMessage] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showPopup_RegisterTraining, setShowPopup_RegisterTraining] = useState(false);
    const [selectedTrainingId, setSelectedTrainingId] = useState(null);
    const trainingIdFromUrl = new URLSearchParams(window.location.search).get('id');
    const [showPopup_NavigateLogin, setShowPopup_NavigateLogin] = useState(false); 

    const navigate = useNavigate();

    
  useEffect(() => {
    // Controleer of de gebruiker is ingelogd
    const user = localStorage.getItem('user');
    const token = localStorage.getItem('token');

    if (!user || !token) {
        if (trainingIdFromUrl) {
            const redirectUrl = `/training_register?id=${trainingIdFromUrl}`;
            console.log("Redirect URL opgeslagen:", redirectUrl);
            sessionStorage.setItem('redirectAfterLogin', redirectUrl);
        } else {
            console.warn("Geen trainingId gevonden in de URL. Redirect URL wordt niet opgeslagen.");
        }
        
        // Toon de login-popup omdat de gebruiker niet is ingelogd
        setShowPopup_NavigateLogin(true);
    } else {
      // Gebruiker is ingelogd, haal het training_id op uit de URL
      const urlParams = new URLSearchParams(window.location.search);
      const trainingId = urlParams.get('id');

      if (trainingId) {
        // Zet de geselecteerde training_id en toon de popup
        setSelectedTrainingId(trainingId);
        setShowPopup_RegisterTraining(true);
      }
    }
  }, [navigate]);

  const handleCancel = async () => {
      setShowPopup_RegisterTraining(false);

      navigate('/my-trainings')
  }

  // Functie om de gebruiker te registreren voor de geselecteerde training
  const handleRegister = async () => {
    if (!selectedTrainingId) {
      console.error('Training ID is missing');
      return;
    }

    setIsLoading(true);
  
    try {
      const user = JSON.parse(localStorage.getItem('user')); // Haal user-object op
      const userId = user.id; // Haal user_id op uit het user-object
      const token = localStorage.getItem('token'); // Haal het token op uit localStorage
  
      // Stap 1: Controleer eerst of de gebruiker al geregistreerd is
      const checkResponse = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/checkRegistration`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`, // Voeg de JWT-token toe aan de headers
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ training_id: selectedTrainingId, user_id: userId }), // Verstuur training_id en user_id in de body
      });
  
      const checkData = await checkResponse.json();
      if (checkData.success && checkData.registered) {
        setIsLoading(false);

        setError('You are already registered for this training. Re-directing to My Trainings...');
        setShowErrorPopup(true);
        
        setTimeout(() => {
          setShowErrorPopup(false);
          navigate('/my-trainings');
        }, 3000);
        
        return; // Stop verdere verwerking        
      }
  
      // Stap 2: Als de gebruiker nog niet is geregistreerd, voer de registratie uit
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/registerTraining`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`, // Voeg de JWT-token toe aan de headers
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ training_id: selectedTrainingId, user_id: userId }), // Verstuur training_id en user_id in de body
      });
  
      if (response.ok) {
        setIsLoading(false);

        // Verberg de popup en navigeer terug naar de My Trainings-pagina
        setShowPopup_RegisterTraining(false);
        setMessage('Successfully registered for the training. Re-directing to My Trainings...');
        setShowPopupMessage(true);

        setTimeout(() => {
          setShowPopupMessage(false);
          navigate('/my-trainings');
        }, 3000);
      } else {
        setIsLoading(false);

        const errorData = await response.json();
        setError(`Registration failed: ${errorData.message || 'Unknown error'}`);
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000); // Verberg de popup na 3 seconden
      }
    } catch (error) {
      setIsLoading(false);

      console.error('Error registering for the training:', error);
      setError('There was an error registering for the training. Please try again.');
      setShowErrorPopup(true);
      setTimeout(() => setShowErrorPopup(false), 3000); // Verberg de popup na 3 seconden
    }
  };
  

    // Functie om door te gaan naar de loginpagina
    const handleGoToLogin = () => {
        setShowPopup_NavigateLogin(false); // Verberg de popup
        navigate('/login'); // Navigeer naar de loginpagina
    };

    // Functie om door te gaan naar de registratiepagina
    const handleGoToRegister = () => {
        setShowPopup_NavigateLogin(false); // Verberg de popup
        navigate('/register'); // Navigeer naar de registratiepagina
    };

  return (
    <div>
      {/* Toon de registratie-popup als de state showPopup_RegisterTraining true is */}
      {showPopup_RegisterTraining && (
        <div className="popup-container">
          <div className="popup-content">
            <h2 style={{ fontWeight: 'normal' }}>Register Training</h2>
            <div className="white-space"></div>
            <div>The training will be added to My Trainings</div>
            <div className="white-space"></div>
            <div className="white-space"></div>
            <div className="buttons-container">
              <button style={{ color: 'black', fontWeight: 'bold' }} onClick={handleRegister}>
                Register
              </button>
              <button onClick={handleCancel} style={{ color: 'black', fontWeight: 'bold' }}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

    {showPopup_NavigateLogin && (
        <div className="popup-container">
        <div className="popup-content">
          <h2>Login Required</h2>
          <p>To register for this training, you need to log in to the iAnalytics Platform first.</p>
          <p>You will be forwarded to the login page. Once logged in, you will be automatically redirected back to this page to complete your registration.</p>
          <p>Don't have an account yet? You can create one by clicking "Create Account" below.</p>
          <div className="buttons-container">
            <button onClick={handleGoToLogin} style={{ color: 'black', fontWeight: 'bold' }}>
              Login
            </button>
            <button onClick={handleGoToRegister} style={{ color: 'black', fontWeight: 'bold' }}>
              Create Account
            </button>
          </div>
        </div>
      </div>
    )}

    {showPopupMessage && <div className="popup-message">{message}</div>}
    {showErrorPopup && <div className="popup">{error}</div>}
    {isLoading && 
        <div className="loader-wrapper">
        <div className="loader"></div>
        </div>
    }
    </div>
  );
};

export default TrainingRegisterComponent;
